import React, { useEffect, useRef, useState } from 'react';
import { db } from '../firebase';
import { addDoc, collection, serverTimestamp, query, onSnapshot, orderBy } from 'firebase/firestore';
import { Typewriter } from 'react-simple-typewriter';
import '../index.css';

export default function MainPage() {
  const sliderRef = useRef(null);
  const [reviews, setReviews] = useState([]);
  const [name, setName] = useState('');
  const [review, setReview] = useState('');
  const [rating, setRating] = useState(5);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const q = query(collection(db, 'reviews'), orderBy('timestamp', 'desc'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setReviews(snapshot.docs.map(doc => doc.data()));
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (sliderRef.current) {
        sliderRef.current.scrollBy({
          left: sliderRef.current.offsetWidth,
          behavior: 'smooth',
        });

        if (
          sliderRef.current.scrollLeft + sliderRef.current.offsetWidth >=
          sliderRef.current.scrollWidth
        ) {
          sliderRef.current.scrollTo({ left: 0, behavior: 'smooth' });
        }
      }
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !review) return;

    try {
      await addDoc(collection(db, 'reviews'), {
        name,
        review,
        rating,
        timestamp: serverTimestamp(),
      });
      setSubmitted(true);
      setName('');
      setReview('');
      setRating(5);
      setTimeout(() => setSubmitted(false), 3000);
    } catch (error) {
      console.error('Error adding review:', error);
    }
  };

  return (
    <>
      <div className="hero">
        <div className="hero-content">
          <h1>The Main Ingredient</h1>
          <h2 className="typewriter">
            <Typewriter
              words={['Healthy.', 'Abaco Soul.', 'Made Fresh.']}
              loop
              cursor
              cursorStyle="|"
              typeSpeed={80}
              deleteSpeed={50}
              delaySpeed={2000}
            />
          </h2>
        </div>
      </div>

      <section className="section section-about">
      <h2>Our Food Philosophy</h2>
      <p className="about-text">
        At The Main Ingredient, we believe in keeping things simple and soulful. Our cuisine focuses on whole, fresh ingredients — prepared with love and Bahamian flair. Whether you’re craving grilled classics, vibrant vegan meals, or wholesome vegetarian dishes, we’ve crafted a menu for everyone to feel nourished.
      </p>
    </section>


      <section className="section-review" id="testimonials">
        <h2>Customer Testimonials</h2>
        <div ref={sliderRef} className="testimonial-slider">
          {reviews.map((r, i) => (
            <div key={i} className="testimonial-card">
              <p>"{r.review}"</p>
              <p><em>- {r.name}</em></p>
              <p>{'⭐'.repeat(r.rating)}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section" id="review-form">
        <h2>Leave Us a Review</h2>
        {submitted && <p className="success">Thanks for your review!</p>}
        <form onSubmit={handleSubmit}>
          <input type="text" placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)} required />
          <textarea placeholder="Your review" value={review} onChange={(e) => setReview(e.target.value)} rows="4" required />
          <label>Rating:</label>
          <select value={rating} onChange={(e) => setRating(parseInt(e.target.value))}>
            {[5, 4, 3, 2, 1].map((star) => (
              <option key={star} value={star}>{star} Star{star > 1 ? 's' : ''}</option>
            ))}
          </select>
          <button type="submit">Submit Review</button>
        </form>
      </section>

      <script src="https://static.elfsight.com/platform/platform.js" async></script>
      <div class="elfsight-app-4851733c-b118-4a90-b546-5869a248aa01" data-elfsight-app-lazy></div>


      <section className="section-centered-full">
        <h2>Hours & Location</h2>
        <p> Marsh Harbour, Abaco</p>
        <p> Mon–Sun: 8am – 7pm</p>
        <p> Leonard M. Thompson International Airport  </p>
      </section>
    </>
  );
}
